import React, { useEffect, useRef, useState } from "react";
import about1 from "../../../Assets/about/about-1.png";
import about2 from "../../../Assets/about/about-2.png";
import about3 from "../../../Assets/about/about-3.png";
import about4 from "../../../Assets/about/about-4.png";
import abouticon1 from "../../../Assets/about/about-icon-1.png";
import abouticon2 from "../../../Assets/about/about-icon-2.png";
import abouticon3 from "../../../Assets/about/about-icon-3.png";
import abouticon4 from "../../../Assets/about/about-icon-4.png";
import aboutsign from "../../../Assets/about/about-sign.png";
import InquiryModal from "../../common/InquiryModal";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showInquiry, setShowInquiry] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="px-4 sm:px-6 md:px-10 py-4 sm:py-8 bg-yellow-50/30 ">
      <div className="grid md:grid-cols-2 gap-10 items-start text-white">
        {/* LEFT: Custom Image Grid */}
        <div className="grid md:grid-cols-10 gap-2 md:gap-4">
          <img
            src={about1}
            alt=""
            className="col-span-7 h-[270px] w-full object-cover rounded-xl"
          />

          <img
            src={about2}
            alt=""
            className="col-span-3 h-[270px] w-full object-cover rounded-xl"
          />

          <img
            src={about3}
            alt=""
            className="col-span-3 h-[270px] w-full object-cover rounded-xl"
          />

          <img
            src={about4}
            alt=""
            className="col-span-7 h-[270px] w-full object-cover rounded-xl"
          />
        </div>

        {/* RIGHT: Content */}
        <div>
          <p className="text-[#92AD36] text-sm font-semibold mb-5 mt-6 tracking-wide">
            ABOUT FERTILIZERS
          </p>

          <h2 className="text-2xl md:text-4xl tracking-wide font-serif mb-5 text-[#000000]">
            Eco-Friendly Nutrients Can Be Made For Better Growth.
          </h2>

          <div className="flex mb-5 gap-2">
            <span className="w-10 h-1 bg-[#92AD36] "></span>
            <span className="w-3 h-1 bg-[#92AD36]"></span>
            <span className="w-5 h-1 bg-[#92AD36]"></span>
          </div>

          <p className="text-[#848484] mb-5 tracking-wide">
            Eco-friendly fertilizers are, the nutrients that do not harm the
            environment. whether in their production or application.
          </p>

          <p className="text-[#848484] mb-5 tracking-wide">
            If anything’s vital in today’s agriculture, it’s improving yield,
            including a broad range of sustainable practices helping farmers
            protect soil health.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6 text-black font-semibold">
            <div className="flex items-center gap-4">
              <img src={abouticon1} alt="" className="w-8 h-8" />
              <span>Soil Enrichment</span>
            </div>

            <div className="flex items-center gap-4">
              <img src={abouticon2} alt="" className="w-8 h-8" />
              <span>Crop Nutrition</span>
            </div>

            <div className="flex items-center gap-4">
              <img src={abouticon3} alt="" className="w-8 h-8" />
              <span>Organic Farming</span>
            </div>

            <div className="flex items-center gap-4">
              <img src={abouticon4} alt="" className="w-8 h-8" />
              <span>Sustainable Growth</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-5 justify-between mt-4 md:mt-16">
            {/* <img src={aboutsign} alt="sign" className=" w-[50%] sm:w-[25%]" /> */}
            <div className="flex gap-5">
              <div className="flex flex-col gap-2">
                <span className="text-[#848484]">Call to ask any question</span>
                <span className="text-[#000000]">+91 98539 32961</span>
              </div>

              <button>
                <button
                  onClick={() => navigate("/about")}
                  className="px-6 py-3 bg-[#92AD36] hover:text-[#92AD36] hover:bg-white border border-[#92AD36] duration-300 rounded-xl text-xs font-semibold"
                >
                  KNOW MORE
                </button>
              </button>
            </div>
          </div>
        </div>
      </div>
      {showInquiry && <InquiryModal onClose={() => setShowInquiry(false)} />}
    </div>
  );
};

export default About;
